import DeviceEditor from './device-editor';

export default DeviceEditor;